import React from 'react';
import AboutSection from './AboutSection';

const AboutUs = () => <AboutSection />;

export default AboutUs;
